import { gql } from '@apollo/client';
export const QUERY = gql `
  query GetCompanyUsers($companyId: UUID!) {
    company: company2(id: $companyId) {
      id
      companyUsers {
        id
        user {
          id
          name
        }
      }
    }
  }
`;
